'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var filterShape = _react.PropTypes.shape({
  value: _react.PropTypes.string,
  count: _react.PropTypes.number,
  label: _react.PropTypes.string
});

exports.default = filterShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/filterShape.js
// module id = 528
// module chunks = 1